import {Component, OnInit} from '@angular/core';

import {LocalStorageService} from '../share/localstorage.service';
import {SyncService} from '../share/sync.service';

@Component({
    selector: 'app-releasenotes',
    templateUrl: './releasenotes.component.html',
    styleUrl: './releasenotes.component.css',
    standalone: false
})
export class ReleasenotesComponent implements OnInit {
    public debug: boolean = false;
    constructor(private ls: LocalStorageService,
                private syncservice: SyncService){
    }

    ngOnInit() {
        this.ls.store('releasenotes',this.syncservice.getAppVersion());
    }

}
